import { render, staticRenderFns } from "./UserSettingsPopup.vue?vue&type=template&id=676d2232&scoped=true&"
import script from "./UserSettingsPopup.vue?vue&type=script&lang=js&"
export * from "./UserSettingsPopup.vue?vue&type=script&lang=js&"
import style0 from "./UserSettingsPopup.vue?vue&type=style&index=0&id=676d2232&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../abbreviation/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "676d2232",
  null
  
)

export default component.exports